/**
 *   Generated file. Do not edit
 */

export const ResourceMetaData = {
  '/wifi/mode': {
    put: {
      minApiVersion: 1.0,
      configModeRequired: false,
      schema: {
        $ref: './definitions.yaml#/WifiMode',
      },
    },
  },

  '/wifi/key': {
    put: {
      minApiVersion: 1.0,
      configModeRequired: false,
      schema: {
        type: 'string',
        minLength: 8,
        maxLength: 64,
      },
    },
  },

  '/wifi/ip': {
    put: {
      minApiVersion: 1.0,
      configModeRequired: false,
      schema: {
        type: 'string',
        format: 'ipv4',
        pattern: '^(?:[0-9]{1,3}\\.){3}[0-9]{1,3}$',
      },
    },
  },

  '/wifi/gateway-ip': {
    put: {
      minApiVersion: 1.0,
      configModeRequired: false,
      schema: {
        type: 'string',
        format: 'ipv4',
      },
    },
  },

  '/wifi/ip-mask': {
    put: {
      minApiVersion: 1.0,
      configModeRequired: false,
      schema: {
        type: 'string',
        format: 'ipv4mask',
      },
    },
  },

  '/wifi/dns-ip': {
    put: {
      minApiVersion: 1.0,
      configModeRequired: false,
      schema: {
        type: 'string',
        format: 'ipv4',
      },
    },
  },

  '/wifi/ssid': {
    put: {
      minApiVersion: 1.0,
      configModeRequired: false,
      schema: {
        type: 'string',
        maxLength: 32,
        minLength: 1,
        pattern:
          '^[^ !#;+\\]\\/"\\t][^+\\]\\/"\\t]{0,30}[^ !#;+\\]\\/"\\t]$|^[^ !#;+\\]\\/"\\t]$',
      },
    },
  },

  '/wifi/country-code': {
    put: {
      minApiVersion: 1.88,
      configModeRequired: false,
      schema: {
        type: 'integer',
        format: 'uint16',
      },
    },
  },

  '/wifi/protocol': {
    put: {
      minApiVersion: 1.88,
      configModeRequired: false,
      schema: {
        type: 'array',
        items: {
          $ref: './definitions.yaml#/WifiProtocol',
        },
      },
    },
  },

  '/wifi/tx-power': {
    put: {
      minApiVersion: 1.88,
      configModeRequired: false,
      schema: {
        type: 'integer',
        format: 'int8',
      },
    },
  },

  '/wifi/ssid-visibility': {
    put: {
      minApiVersion: 1.88,
      configModeRequired: false,
      schema: {
        $ref: './definitions.yaml#/WifiSSIDVisibility',
      },
    },
  },

  '/wifi/key-visibility': {
    put: {
      minApiVersion: 1.88,
      configModeRequired: false,
      schema: {
        $ref: './definitions.yaml#/WifiKeyVisibility',
      },
    },
  },

  '/wifi/network-mode': {
    put: {
      minApiVersion: 2.13,
      configModeRequired: false,
      schema: {
        $ref: './definitions.yaml#/WifiMode',
      },
    },
  },

  '/wifi/disabled': {
    put: {
      minApiVersion: 2.13,
      configModeRequired: false,
      schema: {
        type: 'boolean',
      },
    },
  },
};
